import React, { Fragment } from 'react';
import Navbar2 from '../../components/Navbar2';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import './MisionVisionPage.css'; // Importa el archivo CSS

const MisionVisionPage = () => {
    return (
        <Fragment>
            <Navbar2 />
            <PageTitle pageTitle={'Misión y Visión'} pagesub={'Misión y Visión'} />

            <section className="mision-vision-section">
                <div className="cards-container">
                    {/* Tarjeta de Misión */}
                    <div className="floating-card">
                        <h2>Nuestra Misión</h2>
                        <p>
                            Facilitar la transformación digital en el ámbito contable, financiero y administrativo, 
                            desarrollando y proporcionando soluciones tecnológicas innovadoras que permitan a las 
                            empresas optimizar sus procesos. Nos comprometemos a ofrecer soluciones intuitivas y 
                            personalizadas que mejoren la eficiencia operativa, reduzcan errores y potencien la 
                            toma de decisiones estratégicas.
                        </p>
                    </div>

                    {/* Tarjeta de Visión */}
                    <div className="floating-card">
                        <h2>Nuestra Visión</h2>
                        <p>
                            Ser referencia nacional e internacional en el desarrollo de soluciones tecnológicas 
                            que revolucionan la gestión contable, financiera y administrativa. Buscamos ser 
                            reconocidos por nuestra capacidad de anticipar las necesidades del mercado, ofrecer 
                            innovación constante y establecer estándares de excelencia en la industria.
                        </p>
                    </div>

                    {/* Tarjeta de Valores */}
                    <div className="floating-card">
                        <h2>Nuestros Valores</h2>
                        <ul>
                            <li>
                                <strong>Innovación Continua:</strong> Lideramos el cambio, invirtiendo en investigación y desarrollo para ofrecer soluciones vanguardistas.
                            </li>
                            <li>
                                <strong>Transparencia y Ética:</strong> Mantenemos altos estándares éticos y transparencia en todas nuestras operaciones.
                            </li>
                            <li>
                                <strong>Colaboración Estratégica:</strong> Construimos relaciones duraderas con nuestros clientes y colaboradores.
                            </li>
                            <li>
                                <strong>Excelencia en el Servicio:</strong> Garantizamos la máxima calidad en cada aspecto de nuestros servicios.
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default MisionVisionPage;
